'use client';
import { Fragment } from 'react';
import { Grid } from '@mui/material';
import Link from 'next/link';

// 1. Swap next/router for next/navigation
import { usePathname } from 'next/navigation';

import { formatCategoryUrl, removeLastTrailingSlash } from 'services/lib/util';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

// 2. Update functions to accept 'pathname' instead of 'asPath'
const determineActiveRoute = (route, pathname) => {
  if (!route || !pathname) return false;
  const formattedRoute = removeLastTrailingSlash(formatCategoryUrl(route));
  const formattedPathname = removeLastTrailingSlash(pathname);

  return formattedRoute === formattedPathname;
};

const determineCurrentElement = (dataset, pathname) => {
  let foundElementIndex = 0;
  if (Array.isArray(dataset) && dataset != null) {
    dataset.forEach((item, index) => {
      const formattedRoute = removeLastTrailingSlash(formatCategoryUrl(item.node.uri));
      const formattedPathname = removeLastTrailingSlash(pathname);
      if (formattedRoute === formattedPathname) {
        foundElementIndex = index;
      }
    });
  }
  return foundElementIndex === 0 ? foundElementIndex : foundElementIndex + 1;
};

export const CategoryNavigation = ({ nodeByUri }) => {
  // 3. Initialize Next 16 hook
  const pathname = usePathname();

  // Guard clause to prevent rendering if no data is provided
  if (!nodeByUri) return null;

  const filteredCategories = nodeByUri.children?.edges?.filter((category) => category.node.count != null) || [];

  const initialSlide = determineCurrentElement(filteredCategories, pathname);

  return (
    <Grid className="categoryNavBar px-0" size={12}>
      <nav className="px-0">
        <ul className="px-0">
          <Swiper
            modules={[Navigation]}
            spaceBetween={16}
            slidesPerView={'auto'}
            slideToClickedSlide={true}
            navigation
            initialSlide={initialSlide}
            className="px-0"
          >
            <SwiperSlide
              className={determineActiveRoute(nodeByUri.uri, pathname) ? 'swiper-slide-active item px-0' : 'item px-0'}
              key={0}
            >
              <li className={determineActiveRoute(nodeByUri.uri, pathname) ? 'all active px-0' : 'all px-0'}>
                <Link className="px-0" href={formatCategoryUrl(nodeByUri.uri)}>
                  Wszystkie
                </Link>
              </li>
            </SwiperSlide>

            {filteredCategories.map((category) => {
              return (
                <SwiperSlide
                  className={
                    determineActiveRoute(category.node.uri, pathname) ? 'swiper-slide-active item px-0' : 'item px-0'
                  }
                  key={category.node.id}
                >
                  <li className={determineActiveRoute(category.node.uri, pathname) ? 'active px-0' : 'px-0'}>
                    <Link className="px-0" href={formatCategoryUrl(category.node.uri)}>
                      {category.node.name}
                    </Link>
                  </li>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </ul>
      </nav>
    </Grid>
  );
};
